var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mailto-link"},[_c('a',{attrs:{"href":`mailto:${_vm.email}`}},[_c('FontIcon',{attrs:{"name":"ui_contact"}}),_c('span',{staticClass:"text5"},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }